module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Kode Referral',
          href: '#/referral-code',
          exact: true,
        },
        {
          text: 'Detail Kode Referral'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Detail Kode Referral")]), _vm._v(" "), _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-8"
  }, [_c('v-row', {
    staticClass: "mt-2 mb-4"
  }, [_c('v-col', {
    staticClass: "pt-3",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "font-weight-500",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                                Email Pemilik\n                            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', {
    staticClass: "darkgrey--text font-weight-bold"
  }, [_vm._v("\n                                    " + _vm._s(_vm.details.email) + "\n                                ")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "font-weight-500",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                                User ID\n                            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', {
    staticClass: "darkgrey--text font-weight-bold"
  }, [_vm._v("\n                                    " + _vm._s(_vm.details.user_id) + "\n                                ")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "font-weight-500",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("\n                                Sekolah\n                            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('span', {
    staticClass: "darkgrey--text font-weight-bold"
  }, [_vm._v("\n                                    " + _vm._s(_vm.details.school) + "\n                                ")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_c('span', {
    staticClass: "mr-2 font-weight-700"
  }, [_vm._v("Kode Referral")]), _vm._v(" "), _c('span', {
    staticClass: "darkgrey--text font-weight-bold"
  }, [_vm._v("\n                            " + _vm._s(_vm.details.referral_code) + "\n                        ")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10 mt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Total Penggunaan")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 black--text mt-2",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.details.total_usage) + "\n                            "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Pengguna")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v(" Daftar Pengguna Kode Referral ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.userList,
      "headers": _vm.headers,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-total-items": _vm.pagination.total_data,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: $event.key.value
        };
        _vm.doFilter();
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteProduk(_vm.dialogConfirm.function);
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90d61712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/ReferralCodeDetail.vue
// module id = 2012
// module chunks = 1